// Safe Markdown renderer для privacy policy text — Phase 1 Plan 05.
//
// react-markdown by default strips raw HTML (XSS защита T-01-05-06). Our
// privacy policies committed в repo (apps/api/content/legal/*) and reviewed
// via PR — trusted source. This wrapper provides defence in depth in case
// future versions accidentally pull text от unreliable source.
//
// Naming: "legalRedacted" — placeholder for future PII redaction (Phase 5
// e.g. mask DPO email addresses if env=staging для test data anonymization).

import ReactMarkdown from "react-markdown";

/**
 * Render Markdown safely — НИКАКОЙ raw HTML, no JavaScript URLs.
 *
 * @param md - Markdown source string
 * @returns React element rendering the Markdown
 */
export function renderLegalMarkdown(md: string): React.JSX.Element {
  return <ReactMarkdown>{md}</ReactMarkdown>;
}
